import React, { useEffect, useState } from "react";
import Header from "../components/headerPage";
import { ImPower } from "react-icons/im";
import Footer from "../components/footer";
import background from "../../assets/images/precios.png"
import { useDispatch, useSelector } from 'react-redux';
import Modal from "../components/Modal";
import { Link } from "react-router-dom";
import { FiClock, FiClipboard } from "react-icons/fi";
import { AiOutlineFileText } from "react-icons/ai";
import { CgCheck } from "react-icons/cg";
import { BiX } from "react-icons/bi";
import { BsFillTelephoneFill } from "react-icons/bs";
import { getDataPage } from "../../redux/actions/dataPage";

const Benefit = ({ included, children }) => (
  <li className={`flex items-start mt-2 ${included ? 'text-fondo' : 'text-gray-400'}`}>
    {included
      ? <CgCheck size={24} className="text-primary mt-0.5" />
      : <BiX size={24} className="mt-0.5" />}
    <span className="ml-2 text-sm md:text-base">{children}</span>
  </li>
);

const Card = (props) => {
  const [visible, setVisible] = useState(false);
  const featured = props.tipo === 'Plan Premium';

  return (
    <>
      <Modal visible={visible} title={props.tipo} onClose={() => { setVisible(false) }}>
        <div className="mx-3 w-full flex flex-col items-center">
          <p className="text-base text-center">Gracias por seleccionar el plan {props.tipo}</p>
          <p className="text-base text-center mt-1 text-gray-600">Ir a convocatoria para seleccionar un examen o simulacro</p>
          <div className="flex flex-wrap justify-center" >
            <button className="bg-transparent text-primary border-2 border-primary font-bold py-2 my-5 px-4 rounded-full" onClick={() => {
              setVisible(false)
            }}>Cerrar</button>
            <Link className="bg-primary text-white font-bold py-2 my-5 px-4 rounded-full ml-2" onClick={() => {
              setVisible(false)
            }
            } to="/convocatoria">Ir a convocatoria</Link>
          </div>
        </div>
      </Modal>
      <div className={`bg-white rounded-2xl h-full flex flex-col overflow-hidden border ${featured ? 'border-primary shadow-lg' : 'border-gray-200 shadow-sm'} hover:shadow-lg transition duration-300`}>
        <div className={`h-1.5 w-full ${featured ? 'bg-primary' : 'bg-gray-200'}`}></div>
        <div className="px-6 pt-6 pb-4 text-center">
          {featured && (
            <span className="inline-block text-xs font-semibold uppercase tracking-wide rounded-full px-3 py-1 mb-3 bg-primary bg-opacity-10 text-primary">
              Recomendado
            </span>
          )}
          <p className="text-2xl font-bold text-fondo">{props.tipo}</p>
          <p className="text-4xl font-bold text-fondo mt-3">
            Bs. <span className="text-primary">{props.precio}</span>
          </p>
        </div>

        <div className="px-6 pb-6 flex flex-col flex-1">
          <div className="flex items-start mt-2">
            <FiClock className="text-primary mt-1 mr-2" />
            <div>
              <p className="font-semibold text-fondo text-sm">Suscripción</p>
              <p className="text-gray-600 text-sm">{props.suscripcion}</p>
            </div>
          </div>
          <div className="flex items-start mt-4">
            <FiClipboard className="text-primary mt-1 mr-2" />
            <div>
              <p className="font-semibold text-fondo text-sm">Pruebas prácticas: {props.cantidadPracticas}</p>
              <p className="text-gray-600 text-sm">{props.practicas}</p>
            </div>
          </div>
          <div className="flex items-start mt-4">
            <FiClipboard className="text-primary mt-1 mr-2" />
            <div>
              <p className="font-semibold text-fondo text-sm">Pruebas finales: {props.cantidadfinales}</p>
              <p className="text-gray-600 text-sm">{props.finales}</p>
            </div>
          </div>
          <div className="flex items-start mt-4">
            <AiOutlineFileText className="text-primary mt-1 mr-2" />
            <div>
              <p className="font-semibold text-fondo text-sm">Total de preguntas</p>
              <p className="text-gray-600 text-sm">{props.preguntas}</p>
            </div>
          </div>

          <p className="font-bold text-fondo text-sm uppercase tracking-wide mt-6 mb-1">Beneficios</p>
          <ol className="flex-1">
            <Benefit included={props.uno}>Examen cronometrado</Benefit>
            <Benefit included={props.dos}>Calificación inmediata</Benefit>
            <Benefit included={props.tres}>Revisión</Benefit>
            <Benefit included={props.cuatro}>Gráficos comparativos</Benefit>
            <Benefit included={props.cinco}>Puede modificar la fecha de sus exámenes finales</Benefit>
            <Benefit included={props.seis}>Puede modificar las materias de los exámenes</Benefit>
          </ol>

          <button onClick={() => { setVisible(!visible) }} className={`font-semibold py-3 px-4 rounded-full mt-6 w-full ${featured ? 'bg-primary text-white hover:bg-fondo' : 'bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white'}`}>
            Suscribirse
          </button>
        </div>
      </div>
    </>
  );
};

const Pricing = () => {
  const store = useSelector(state => state.dataPage);
  const [data, setData] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDataPage());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setData(store);
  }, [store]);

  useEffect(() => {
    const bar = document.getElementById('bar');
    if (bar) {
      bar.style.display = 'block';
    }
  }, []);

  return (
    <>
      <Header titulo={"Nuestros Planes"} nombre={"Planes"} mensaje={"Adquiere ahora un Plan"} image={background} />
      <div className="w-full py-12 md:py-16 px-6 md:px-16 lg:px-24 bg-white">
        <div className="landing-wrap flex flex-col md:flex-row">
        <div className="w-full md:w-2/4 p-4 text-center md:text-left">
          <p className="text-sm text-primary font-bold uppercase tracking-widest">Nosotros somos expertos</p>
          <p className="text-2xl md:text-3xl font-bold text-fondo mt-2">Brindamos la mejor solución al cliente para su preparación.</p>
        </div >
        <div className="w-full md:w-1/4 p-4 text-center md:text-left">
          <div className="bg-primary bg-opacity-10 rounded-full p-3 inline-flex">
            <ImPower size={28} className="text-primary" />
          </div>
          <p className="text-lg font-bold my-3 text-fondo">Optimiza tu tiempo</p>
          <p className="text-base text-gray-600">La plataforma Apriori permite que tengas mejor administración del tiempo al momento de rendir el examen.</p>
        </div>
        <div className="w-full md:w-1/4 p-4 text-center md:text-left">
          <div className="bg-primary bg-opacity-10 rounded-full p-3 inline-flex">
            <ImPower size={28} className="text-primary" />
          </div>
          <p className="text-lg font-bold my-3 text-fondo">Familiaridad con el examen</p>
          <p className="text-base text-gray-600">Una prueba simulacro te permite familiarizarte con lo que te encontrarás en tu examen, generando así mayor confianza.</p>
        </div>
        </div>
      </div>

      <div className="w-full bg-gray-100 px-6 py-10 flex flex-col items-center">
        <h3 className="text-center text-fondo font-bold text-2xl md:text-3xl">Planes disponibles únicamente para la convocatoria</h3>
        <h3 className="text-center text-primary font-semibold text-xl md:text-2xl mt-2">{data ? data.dataPage[0]?.tituloBanner : null}</h3>
        <p className="text-gray-600 text-center mt-4 max-w-2xl">Contáctanos para consultar sobre otros planes para una convocatoria diferente.</p>
        <a href="https://api.whatsapp.com/send?phone=59157953389&text=Hola%20quisiera%20saber%20más%20sobre%20los%20planes%20de%20Apriori"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-primary text-white font-bold py-3 px-6 rounded-full mt-5 flex items-center justify-center hover:bg-fondo transition duration-300"
        >
          <BsFillTelephoneFill className="mr-2" />
          Contáctanos
        </a>
      </div>

      <div className="w-full px-6 py-12 bg-white">
        <div className="landing-wrap">
          <p className="text-center text-primary text-sm font-bold uppercase tracking-widest">Plan rápido</p>
          <h4 className="text-center text-fondo font-bold text-2xl md:text-3xl mt-2">Ahora tenemos un plan, pruébalo ahora</h4>
          <div className="bg-white w-full md:w-2/3 lg:w-1/2 p-6 md:p-8 my-8 rounded-2xl border border-primary shadow-sm mx-auto">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-2xl font-bold text-fondo">Plan Fast</p>
                <p className="text-gray-600 text-sm mt-2">Disponible solo el día de la adquisición. Al finalizar el tiempo se cierra la sesión.</p>
              </div>
              <p className="text-4xl font-bold text-fondo mt-4 md:mt-0">Bs. <span className="text-primary">60</span></p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 text-sm">
              <p className="flex items-start text-gray-600"><FiClock className="text-primary mt-1 mr-2" /><span><span className="font-semibold text-fondo">Suscripción:</span> Hasta las 23:59 del día de suscripción</span></p>
              <p className="flex items-start text-gray-600"><FiClipboard className="text-primary mt-1 mr-2" /><span><span className="font-semibold text-fondo">Prácticas:</span> 3 · Más de 25 en cada examen</span></p>
              <p className="flex items-start text-gray-600"><FiClipboard className="text-primary mt-1 mr-2" /><span><span className="font-semibold text-fondo">Finales:</span> 1 · Más de 40 en el examen</span></p>
              <p className="flex items-start text-gray-600"><AiOutlineFileText className="text-primary mt-1 mr-2" /><span><span className="font-semibold text-fondo">Preguntas:</span> Más de 290</span></p>
            </div>
            <ul className="flex flex-wrap mt-4">
              {['Examen cronometrado', 'Calificación inmediata', 'Revisión', 'Gráficos comparativos'].map((item) => (
                <li key={item} className="flex items-center text-sm text-fondo mr-4 mt-2">
                  <CgCheck size={22} className="text-primary" /> {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="w-full py-12 md:py-16 px-6 md:px-10 bg-gray-100" >
        <div className="landing-wrap grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
        <Card
          tipo={"Plan Básico"}
          precio={'120'}
          uno={true}
          dos={true}
          tres={true}
          cuatro={true}
          suscripcion='Hasta el día del examen'
          cantidadPracticas='3'
          cantidadfinales='1'
          practicas='Más de 50 preguntas en cada examen'
          finales='Más de 40 preguntas en cada prueba'
          preguntas='Más de 190 preguntas'
        />

        <Card
          tipo={"Plan Profesional"}
          precio={'210'}
          uno={true}
          dos={true}
          tres={true}
          cuatro={true}
          cinco={true}
          cantidadPracticas='5'
          cantidadfinales='2'
          suscripcion='Hasta el día del examen'
          practicas='Más de 50 preguntas en cada examen'
          finales='Más de 40 preguntas en cada prueba'
          preguntas='Más de 330 preguntas'
        />

        <Card
          tipo={"Plan Premium"}
          precio={'290'}
          uno={true}
          dos={true}
          tres={true}
          cuatro={true}
          cinco={true}
          seis={true}
          cantidadPracticas='8'
          cantidadfinales='2'
          suscripcion='Hasta el día del examen'
          practicas='Más de 50 preguntas en cada examen'
          finales='Más de 40 preguntas en cada prueba'
          preguntas='Más de 480 preguntas'
        />
        </div>
      </div>
      <Footer />

    </>
  );
}

export default Pricing;
